// client/src/components/EditPOI_parts/EditPOI_MoveCategoryModal.js
import React from 'react';

export default function EditPOIMoveCategoryModal({
  open,
  moveMode,
  setMoveMode,
  moveExistingOptions,
  moveTargetExisting,
  setMoveTargetExisting,
  moveTargetNew,
  setMoveTargetNew,
  moveableTypes,
  selectedOtherTypeIds,
  onToggleOtherType,
  onConfirm,
  onClose,
}) {
  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: '#0009',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <div
        style={{
          width: 560,
          maxWidth: '92vw',
          background: '#232427',
          color: '#e2e4e9',
          borderRadius: 14,
          boxShadow: '0 10px 28px #000c',
          padding: 20,
        }}
      >
        <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 6 }}>Move to Category</div>
        <div style={{ color: '#c9cbcf', fontSize: 13, marginBottom: 14 }}>
          The POI’s current type will be moved. Optionally move other types from the old category
          too.
        </div>

        <div style={{ display: 'grid', gap: 10, marginBottom: 16 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input
              type="radio"
              name="moveMode"
              checked={moveMode === 'existing'}
              onChange={() => setMoveMode('existing')}
            />
            <span>Choose existing category</span>
          </label>
          {moveMode === 'existing' && (
            <select
              value={moveTargetExisting}
              onChange={e => setMoveTargetExisting(e.target.value)}
              style={{
                width: '100%',
                background: '#333',
                color: '#fff',
                border: '1px solid #444',
                borderRadius: 8,
                padding: '10px 12px',
              }}
            >
              {moveExistingOptions.length === 0 && <option value="">No categories available</option>}
              {moveExistingOptions.map(n => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
          )}

          <label
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              marginTop: 6,
            }}
          >
            <input
              type="radio"
              name="moveMode"
              checked={moveMode === 'new'}
              onChange={() => setMoveMode('new')}
            />
            <span>Create new category</span>
          </label>
          {moveMode === 'new' && (
            <input
              value={moveTargetNew}
              onChange={e => setMoveTargetNew(e.target.value)}
              placeholder="New category name"
              style={{
                width: '100%',
                background: '#333',
                color: '#fff',
                border: '1px solid #444',
                borderRadius: 8,
                padding: '10px 12px',
              }}
            />
          )}
        </div>

        <div style={{ marginBottom: 10 }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>Other Types in Current Category</div>
          {moveableTypes.length === 0 ? (
            <div style={{ fontSize: 13, color: '#9aa0a6' }}>No other types in this category.</div>
          ) : (
            <div
              style={{
                maxHeight: 220,
                overflow: 'auto',
                border: '1px solid #3a3a3a',
                borderRadius: 8,
                padding: 8,
              }}
            >
              {moveableTypes.map(t => (
                <label
                  key={t.id}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '6px 4px',
                  }}
                >
                  <input
                    type="checkbox"
                    checked={selectedOtherTypeIds.has(t.id)}
                    onChange={() => onToggleOtherType(t.id)}
                  />
                  <span>
                    {t.name}
                    {t.poi_count ? ` (${t.poi_count})` : ''}
                  </span>
                </label>
              ))}
            </div>
          )}
          <div style={{ fontSize: 12, color: '#9aa0a6', marginTop: 6 }}>
            The current POI’s type is always moved.
          </div>
        </div>

        <div
          style={{
            marginTop: 18,
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 10,
          }}
        >
          <button
            onClick={onClose}
            style={{
              background: '#444',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              padding: '8px 16px',
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              background: '#4cc153',
              color: '#101314',
              border: 'none',
              borderRadius: 8,
              padding: '8px 16px',
              fontWeight: 800,
              cursor: 'pointer',
            }}
          >
            Move
          </button>
        </div>
      </div>
    </div>
  );
}
